import * as serializeJavascript from 'serialize-javascript';

import { type AnalyticsConfig } from './analytics';
import { type SentryConfig } from './entry';
import { type AppState } from './store/types';

type BrowserGlobals = Partial<{
  __ENTRY_CONTEXT__: {
    css: string[];
    js: string[];
    nonce: string;
    dataServiceUrl: string;
    sentryConfig: SentryConfig | undefined;
    analyticsConfig: AnalyticsConfig | undefined;
  };
  __INITIAL_REDUX_STATE__: AppState;
}>;

declare global {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface Window extends BrowserGlobals {}
}

interface Props<K extends keyof BrowserGlobals> {
  name: K;
  nonce: string;
  value: BrowserGlobals[K];
}

export function BrowserGlobal<K extends keyof BrowserGlobals>({
  name,
  nonce,
  value,
}: Props<K>) {
  return (
    <script
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: `${name}=${serializeJavascript(value, { isJSON: true })}`,
      }}
      nonce={nonce}
      suppressHydrationWarning
    />
  );
}
